interface Steps {
  route: string;
  name: string;
  completed: boolean;
  hasError?: boolean;
  url: string;
  buttonLabel: string;
  currentStep: number;
}
const getSteps = (
  route: string,
  name: string,
  completed: boolean,
  url: string,
  buttonLabel: string,
  currentStep: number
): Steps => {
  return { route, name, completed, hasError: false, url, buttonLabel, currentStep };
};
export const Constants = {
  createSteps: [
    getSteps('entitydetails', 'Legal Entity Details', false, '/', 'save and continue', 0),
    getSteps('parties', 'Add Parties', false, '/', 'save and continue', 0),
    getSteps('documents', 'Upload Documents', false, '/', 'save and continue', 0),
    getSteps('entityreview', 'Legal Entity Review', false, '/', 'save and continue', 0),
    getSteps('accountdetails', 'Account Details', false, '/', 'save and continue', 0),
    getSteps('features', 'Add Features & Services', false, '/', 'save and continue', 0),
    getSteps('review', 'Review & Sign', false, '/', 'save and continue', 0),
    getSteps('sign', 'Sign', false, '/', 'submit', 0),
  ],
  featuresDrawerList: [
    'cash sweep option',
    'tax accounting parameters',
    'reporting parameters',
    'performance reporting & analytics',
    'data feeds',
    'funding instructions',
  ],
};

export const editRoutesException = ['documents', 'entitycategory'];
